import { render, staticRenderFns } from "./AttendanceChat.vue?vue&type=template&id=7f50464d"
import script from "./AttendanceChat.vue?vue&type=script&lang=js"
export * from "./AttendanceChat.vue?vue&type=script&lang=js"
import style0 from "./AttendanceChat.vue?vue&type=style&index=0&id=7f50464d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerIos,QSpinner,QVirtualScroll});
